<template>
  <div class="personal-wallpaper-detail">
    <div class="hd">
      <span
        class="btn-back"
        @click="handleBackAuthor"
      >作者首页</span>
      <h1>{{ dynamicdetail.wname }}</h1>
    </div>
    <div class="bd">
      <strong
        v-if="dynamicdetail.status === 0"
        class="wallpaper-disable"
      >该壁纸已下架</strong>
      <template v-else>
        <span
          v-if="!hideTips"
          class="time-tip"
        >只能预览动态壁纸前10秒哦~</span>
        <video
          :poster="dynamicdetail.preview_jpg_raw"
          :src="dynamicdetail.preview_video"
          controls
          controlslist="nodownload"
          @click="handlePlay"
          @play="handlePlay"
        />
      </template>
    </div>
    <div class="bt">
      <div class="userface">
        <img
          :src="info.avatar"
          alt
        >
      </div>
      <div class="username">
        {{ info.nickname }}
      </div>
      <i
        v-if="info.user_type === 1"
        class="icon-uup"
      />
      <div
        v-if="useWallpaperVisible"
        class="ctrl"
      >
        <span
          class="btn-download"
          @click="handleShowDownloadTips"
        >
          <i class="icon-download" />
          <span>使用该壁纸</span>
        </span>
      </div>
    </div>
    <template v-if="downloadTipsVisible">
      <div class="mask-tips" />
      <div class="download-tips">
        <i
          class="close"
          @click="handleHideDownloadTips"
        />
        <dl>
          <dt>温馨提示</dt>
          <dd>使用该动态壁纸必须下载“元气桌面”</dd>
        </dl>
        <div class="c">
          <span
            class="btn btn-cancel"
            @click="handleHideDownloadTips"
          >取消</span>
          <a
            :href="transformProtocol(info.install_pkg)"
            class="btn btn-confirm"
            rel="noopener noreferrer"
            @click="handleHideDownloadTips"
          >下载</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import wx from 'weixin-js-sdk'

export default {
  name: 'PersonalWallpaperDetail',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      },
    },
    dynamicdetail: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      hideTips: false,
      downloadTipsVisible: false,
      useWallpaperVisible: false,
      // 是否已经更新过分享信息
      hadSetAppShareMessage: false,
    }
  },
  computed: {
    ...mapState({
      isLoadWxSdk: state => state.isLoadWxSdk,
    }),
  },
  watch: {
    isLoadWxSdk: {
      handler(status) {
        if (status && !this.hadSetAppShareMessage) {
          this.hadSetAppShareMessage = true
          this.onMenuShareAppMessage()
        }
      },
      immediate: true,
    },
  },
  methods: {
    transformProtocol(value) {
      if (typeof value === 'string') {
        return value.replace(/https?:/, '')
      }

      return value
    },
    handlePlay() {
      this.useWallpaperVisible = true
      this.downloadTipsVisible = true
      this.hideTips = true
    },
    handleBackAuthor() {
      this.$router.push({
        path: '/personal/author',
        query: { author_uid: this.info.uid },
      })
    },
    handleShowDownloadTips() {
      this.downloadTipsVisible = true
    },
    handleHideDownloadTips() {
      this.downloadTipsVisible = false
    },
    onMenuShareAppMessage() {
      wx.checkJsApi({

        jsApiList: [
          'checkJsApi',
          'onMenuShareTimeline', // 分享到微信朋友圈
          'onMenuShareAppMessage', // 分享给微信朋友
          'onMenuShareQQ', // 分享到QQ
          'onMenuShareQZone', // 分享到QQ空间
          'updateAppMessageShareData', // 分享到微信及QQ（新接口）
          'updateTimelineShareData'],
        success: (res) => {
          console.log('checkJsApi success: ', res)
          wx.updateAppMessageShareData({
            title: '元气桌面', // 分享标题
            desc: '终于找到我最喜欢的壁纸了，推荐你一起使用', // 分享描述
            // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: location.href.replace(/#.*$/, ''),
            imgUrl: this.dynamicdetail.preview_jpg, // 分享图标
            success() {
              // 设置成功
              console.log('updateAppMessageShareData api success  成功')
            },
            fail(err) {
              console.log('updateAppMessageShareData api err  失败', err)
            },
          })

          wx.updateTimelineShareData({
            title: '元气桌面', // 分享标题
            desc: '终于找到我最喜欢的壁纸了，推荐你一起使用', // 分享描述
            link: location.href.replace(/#.*$/, ''), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.dynamicdetail.preview_jpg, // 分享图标
            success() {
              // 设置成功
              console.log('updateTimelineShareData api success 成功')
            },
            fail(err) {
              console.warn('updateTimelineShareData api err 失败', err)
              wx.closeWindow()
            },
          })
        },
        fail: (err) => {
          console.log('check api fail:', err)
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.personal-wallpaper-detail {
  position: relative;
  padding: 18px 0 12px;
  font-size: 14px;
  color: #727c8e;
  .hd {
    position: relative;
    padding: 0 30px;
  }
  h1 {
    display: inline-block;
    vertical-align: middle;
    font-size: 20px;
    color: #333;
  }
  .btn-back {
    display: inline-block;
    vertical-align: middle;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    margin-right: 22px;
    padding: 0 6px;
    background: #e3e5e8;
    border-radius: 6px;
    cursor: pointer;
    &::before {
      content: '';
      display: inline-block;
      width: 12px;
      height: 10px;
      margin-right: 5px;
      background: url('~@/assets/images/arrow-left.png') 0 0 no-repeat;
    }
  }
  .bd {
    position: relative;
    width: 960px;
    height: 540px;
    margin: 23px auto 18px;
    background: #000;
    overflow: hidden;
    video,
    img {
      width: 100%;
      height: 100%;
    }
    .wallpaper-disable {
      position: absolute;
      top: 250px;
      left: 0;
      right: 0;
      font-size: 20px;
      text-align: center;
      letter-spacing: 10px;
      color: #fff;
    }
  }
  .bt {
    position: relative;
    width: 960px;
    margin: 0 auto;
    .btn-download {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .userface {
    display: inline-block;
    vertical-align: middle;
    width: 48px;
    height: 48px;
    margin-right: 13px;
    background: #999;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .username {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    color: #333;
  }
  .icon-uup {
    display: inline-block;
    vertical-align: middle;
    width: 86px;
    height: 26px;
    background: url('~@/assets/images/uup.png') 0 0 no-repeat;
  }
  .icon-download {
    display: inline-block;
    vertical-align: middle;
    width: 13px;
    height: 12px;
    background: url('~@/assets/images/icon-download.png') 0 0 no-repeat;
  }
  .btn-download {
    display: inline-block;
    height: 44px;
    padding: 0 36px;
    line-height: 44px;
    font-size: 14px;
    border-radius: 10px;
    background: #f4c000;
    color: #000;
    cursor: pointer;
    &:hover {
      background: #ffda53;
    }
    &:active {
      background: #dfaf00;
    }
    i {
      margin-right: 8px;
    }
  }
  .tips {
    position: absolute;
    right: 186px;
    bottom: 16px;
    font-size: 12px;
    color: #b1b5c2;
  }
  .time-tip {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 110px;
    line-height: 40px;
    text-align: center;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    font-size: 14px;
    color: #fff;
  }
  .mask-tips {
    z-index: 8;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .download-tips {
    z-index: 9;
    position: fixed;
    left: 50%;
    top: 50%;
    width: 400px;
    height: 167px;
    margin: -84px 0 0 -200px;
    background: #000;
    border-radius: 10px;
    dl {
      margin-top: 28px;
      text-align: center;
      font-size: 14px;
      color: #fff;
    }
    dt {
      margin-bottom: 14px;
      font-size: 16px;
    }
    .c {
      padding-top: 30px;
      text-align: center;
      .btn {
        margin: 0 10px;
      }
    }
    .btn-cancel {
      display: inline-block;
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      background: #fff;
      border-radius: 8px;
      color: #333;
      cursor: pointer;
    }
    .btn-confirm {
      display: inline-block;
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      background: #f4c000;
      border-radius: 8px;
      color: #333;
      cursor: pointer;
    }
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    background: url('~@/assets/images/close3.png') -20px 0 no-repeat;
    cursor: pointer;
  }
}
</style>
